import type { RoomType } from "building-types/rooms/roomTypesEnum";
import { RoomTagCapitalization } from "building-types/views/planSets";
import { snakeCaseToTitleCase, toTitleCase } from "common/utils/strings";

export function applyRoomTagCapitalization(value: string, capitalization: RoomTagCapitalization): string {
  switch (capitalization) {
    case RoomTagCapitalization.UPPER_CASE:
      return value.toUpperCase();
    case RoomTagCapitalization.TITLE_CASE:
      return toTitleCase(value);
    case RoomTagCapitalization.DEFAULT:
      return value;
  }
}

export function roomTypeParameterValue(roomType: RoomType): string {
  return snakeCaseToTitleCase(roomType);
}
